import { Button, ButtonProps } from '@sgme/ui';

type InfoIconButtonProps = Omit<ButtonProps, 'children' | 'iconPosition' | 'purpose' | 'color'>;

export function InfoIconButton(props: InfoIconButtonProps) {
  return (
    <Button size="sm" {...props} iconPosition="icon-only" purpose="link">
      <i className="icon">info_outline</i>
    </Button>
  );
}
